export interface iPreference {
  language: AvailableLanguages;
  previousDomain?: string;
}

export enum AvailableLanguages {
  "ENGLISH" = "en",
  "DUTCH" = "nl"
}
